var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame-container",class:_vm.fontFamilyByLanguage},[_c('banner'),_c('navigate'),_c('quick-menu',{attrs:{"position":"bottom-right","backgroundColor":"#EB6100"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }